export default function College() {}